export const getHeader = (header: string | string[]) => {
  if (Array.isArray(header)) {
    return header[0]
  }
  return header
}

export const getHeaderAsArray = (headers: string | string[]) => {
  if (Array.isArray(headers)) {
    return headers
  }
  return [headers]
}

export const query = (query: { [ key: string ]: string | number | boolean | null | undefined }, encodeURI = true) => {
  return Object.keys(query)
    .filter(key => !!query[key])
    .map(key => key + '=' + (encodeURI ? encodeURIComponent(query[key]!.toString()) : query[key]!.toString()))
    .join('&')
}

export const parseQuery = (url: string) => {
  const start = Math.max(url.indexOf("?")+1, 0)
  return Object.fromEntries(
    url
      .slice(start)
      .split("&")
      .map(item => item.split("="))
      .map(([ key, item ]) => [ key, item? decodeURIComponent(item): true ])
  )
}

export const parseCookie = (str: string): { [ key: string ]: string } => {
  return str
    .split(';')
    .map(v => v.split('='))
    .filter(v => v.length === 2)
    .reduce((acc, v) => {
      (acc as any)[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim())
      return acc
    }, {})
}
